import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { Field } from '../../field/component';

import './view.scss';

export const FilterView = ({
    headline,
    options,
    filter,
    properties,
    isVisible,
    setFilter,
    toggleVisibility,
    isBestseller,
    isFavorite
}) => {
    // if there is no filter option for current filter - don't render element
    if (!options.length) {
        return null;
    }

    return (
        <div
            className={
                classnames('filter', {
                    'filter--active': isVisible
                })
            }
        >
            <h4 className="filter__headline">{ headline }</h4>
            {
                options.slice(
                    0,
                    (isVisible)
                        ? (options.length)
                        : (5)
                ).map((currentValue, index) => (
                    currentValue && (
                        <Field
                            name={ currentValue }
                            type="checkbox"
                            filter={ filter }
                            properties={ properties }
                            key={ index }
                            setFilter={ setFilter }
                            isBestseller={ isBestseller }
                            isFavorite={ isFavorite }
                        />
                    )
                ))
            }
            {
                (options.length > 5)
                    && (
                        <button
                            className="filter__button"
                            type="button"
                            onClick={ () => {
                                toggleVisibility();
                            } }
                        >
                            {
                                (isVisible)
                                    ? ('Zobacz mniej')
                                    : ('Zobacz więcej')
                            }
                        </button>
                    )
            }
        </div>
    );
};

FilterView.defaultProps = {
    isBestseller: false,
    isFavorite: false
};

FilterView.propTypes = {
    headline: PropTypes.string.isRequired,
    options: PropTypes.instanceOf(Array).isRequired,
    filter: PropTypes.string.isRequired,
    properties: PropTypes.instanceOf(Set).isRequired,
    isVisible: PropTypes.bool.isRequired,
    setFilter: PropTypes.func.isRequired,
    toggleVisibility: PropTypes.func.isRequired,
    isBestseller: PropTypes.bool,
    isFavorite: PropTypes.bool
};